import React from 'react';
import { useModel } from '../core/hooks';
import WidgetNode from './widget-node';
import { VevContent } from 'vev';

function Fixed({ pageKey }: { pageKey: string }) {
  const fixed: VevContent['fixed'] = useModel('fixed') || ({} as any);
  if (!pageKey || !fixed) return null;
  const { children = [], visibility = {} } = fixed;

  return (
    <>
      {children
        // @ts-ignore
        .filter((id) => !visibility[id] || visibility[id] === true || visibility[id][pageKey])
        .map((id) => (
          <WidgetNode key={id} id={id} fixed />
        ))}
    </>
  );
}

export default React.memo(Fixed);
